module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a4qSO"))).then(() => module.bundle.root('dsisd'));